import React, {useContext} from 'react';
import { Form, Button} from 'react-bootstrap'
import {Link, Redirect, useHistory} from "react-router-dom";
import {FormikControl} from "./Components";
import {Formik} from "formik";
import {SessionContext} from "./SessionContext";
import type {WebCredentials} from "../services/API";
import Consents from "./Consents";
import PrintersTab from "./PrintersTab";
import type {SessionContextType} from "./SessionContext";
import documaster_logo from "../styles/images/documaster.png";
import Terms from "./legal/Terms";
import PrivacyPolicy from "./legal/PrivacyPolicy";

const Login = () => {

  const context: SessionContextType = useContext(SessionContext);
  const history = useHistory();

  //https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/Redirect.js
  if (context.needsConsents) return <Redirect to={Consents.url} push={true} />;
  else if (context.logged) return <Redirect to={PrintersTab.url} push={true}/>;

  const validate = (values) => {
    let errors = {};
    if (!values.user) errors.user = 'Nazwa użytkownika jest wymagana';
    else if (values.user.indexOf('@') === -1) {
      errors.user = 'Domena jest wymagana. Pełna postać loginu to [użytkownik]@[domena]';
    }
    if (!values.password) errors.password = 'Hasło jest wymagane'
    return errors;
  }

  const submit = (credentials: WebCredentials, {setSubmitting}) => {
    setSubmitting(true);
    context.login(credentials, (response: AuthResponse)=>{
      setSubmitting(false);
      if (context.needsConsents) history.push(Consents.url);
      else history.push(PrintersTab.url);
    });
  }

  return <div className="login-page">
    <div className="login-brand">
      <img className="login-logo" src={documaster_logo} alt="Documaster"/>
      <div className="login-product">GlobalService</div>
    </div>

    <div className="login-card">
      <h1 className="login-card-title">Zaloguj się</h1>
      <Formik initialValues={{user: '', password: '', rememberMe: false}} onSubmit={submit} validate={validate}>
        {({handleSubmit, isSubmitting }) => (
            <Form noValidate onSubmit={handleSubmit} className="login-form">
              <Form.Group controlId="userId">
                <Form.Label>Użytkownik</Form.Label>
                <FormikControl type="text" autoFocus name="user" placeholder="użytkownik@domena"/>
              </Form.Group>
              <Form.Group controlId="password">
                <Form.Label>Hasło</Form.Label>
                <FormikControl type="password" name="password" placeholder="••••••••"/>
              </Form.Group>
              <Form.Group controlId="rememberMeId" className="login-remember">
                <FormikControl type="checkbox" name="rememberMe" label="Zapamiętaj mnie"/>
              </Form.Group>
              <Button variant="primary" type="submit" disabled={isSubmitting} className="login-submit" block>
                {isSubmitting ? 'Logowanie...' : 'Zaloguj'}
              </Button>
            </Form>
        )}
      </Formik>
    </div>

    <div className="login-footer">
      {!context.connected && <span className="login-no-connection">Brak połączenia z serwerem</span>}
      <span className="legal-links">
        <Link to={Terms.url}>Regulamin</Link>
        <Link to={PrivacyPolicy.url}>Polityka prywatności</Link>
      </span>
      <span className="login-copy">{new Date().getFullYear()} Euroimpex SA</span>
    </div>
  </div>;
}

Login.url = '/login'

export default Login;